export default __webpack_public_path__ + "static/media/Mood.0abc27b6.png";